import React, {useEffect} from 'react';
import Common from "./common"

const Add = () => {
    return <><Common/></>;
}

export default Add;
